<template>
  <div>
    <transferenceManagebar />
    <v-container fluid>
      <base-material-card
        icon="mdi-robot"
        title="ระบบประมวลผลย้ายสายบริหารแบบอัตโนมัติ (เสนอผล — ต้องยืนยันก่อนบันทึกจริง)"
      >
        <v-alert type="info" outlined dense class="mb-4">
          ระบบจะ<strong>เสนอ</strong>การจับคู่ผู้ขอย้ายกับตำแหน่งว่างเท่านั้น ยังไม่มีการบันทึกข้อมูลใดๆ
          จนกว่าแอดมินจะตรวจสอบและกด "ยืนยัน" เป็นรายการ พิจารณาเฉพาะปลายทางที่สถานศึกษาให้ความเห็น
          "เห็นควรให้รับย้าย" แล้วเท่านั้น
        </v-alert>

        <v-row dense class="align-center">
          <v-col cols="12" md="4">
            <v-radio-group v-model="position" row hide-details class="mt-0">
              <v-radio label="ผู้อำนวยการวิทยาลัย" value="ผู้อำนวยการวิทยาลัย"></v-radio>
              <v-radio label="รองผู้อำนวยการวิทยาลัย" value="รองผู้อำนวยการวิทยาลัย"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="4">
            <v-btn color="primary" :loading="loading" @click="runMatchEngine">
              <v-icon left>mdi-robot</v-icon>ประมวลผลจับคู่อัตโนมัติ
            </v-btn>
          </v-col>
          <v-col cols="12" md="4" class="text-md-right">
            <v-btn small rounded color="success" dark :disabled="!suggestions.length" @click="exportToExcel">
              <v-icon left small>mdi-file-excel</v-icon>Export Excel
            </v-btn>
          </v-col>
        </v-row>

        <h3 class="mt-4">ผลการเสนอจับคู่ ({{ suggestions.length }} รายการ)</h3>
        <v-data-table
          :headers="suggestionHeaders"
          :items="suggestions"
          item-key="manage_location_id_tfl"
          :loading="loading"
          disable-pagination
          hide-default-footer
          show-select
          v-model="selectedSuggestions"
        >
          <template v-slot:item.destination_college_name="{ item }">
            <v-select
              v-if="item.alternative_choices && item.alternative_choices.length > 1"
              v-model="item.chosen_tfl"
              :items="item.alternative_choices"
              item-text="destination_college_name"
              item-value="manage_location_id_tfl"
              dense
              hide-details
              @change="onOverrideDestination(item)"
            ></v-select>
            <span v-else>{{ item.destination_college_name }}</span>
          </template>
          <template v-slot:item.destination_capacity="{ item }">
            <v-chip small color="teal" dark>
              {{ item.destination_used }}/{{ item.destination_capacity }} ตำแหน่ง (jor18)
            </v-chip>
          </template>
          <template v-slot:item.composite_score="{ item }">
            <v-chip small color="primary" dark>{{ item.composite_score }}</v-chip>
          </template>
          <template v-slot:item.breakdown="{ item }">
            <span class="caption">
              ลำดับ {{ item.breakdown.pref_score }} / ผบช.
              <span v-if="item.breakdown.no_score">(ไม่มีคะแนน)</span>
              <span v-else>{{ item.breakdown.sup_score }}</span>
              / อายุงาน {{ item.breakdown.sen_score }}
            </span>
          </template>
          <template v-slot:item.confirm_action="{ item }">
            <v-btn x-small color="success" :loading="item.confirming" @click="confirmSuggestion(item)">
              ยืนยัน
            </v-btn>
          </template>
        </v-data-table>

        <v-btn
          class="mt-3"
          color="success"
          :disabled="!selectedSuggestions.length"
          :loading="bulkConfirming"
          @click="confirmSelected"
        >
          <v-icon left>mdi-check-all</v-icon>ยืนยันรายการที่เลือก ({{ selectedSuggestions.length }})
        </v-btn>

        <template v-if="declined.length">
          <h3 class="mt-6">ปลายทางเต็มโควตา ไม่ได้เสนอจับคู่ ({{ declined.length }} รายการ)</h3>
          <v-data-table
            :headers="declinedHeaders"
            :items="declined"
            item-key="manage_location_id_tfl"
            disable-pagination
            hide-default-footer
          ></v-data-table>
        </template>

        <template v-if="unmatched.length">
          <h3 class="mt-6">ยังไม่ได้จับคู่ ({{ unmatched.length }} คน — จัดการด้วยมือต่อที่หน้ารายละเอียดผู้ยื่นย้าย)</h3>
          <v-data-table
            :headers="unmatchedHeaders"
            :items="unmatched"
            item-key="id_card"
            disable-pagination
            hide-default-footer
          ></v-data-table>
        </template>
      </base-material-card>
    </v-container>

    <v-container fluid>
      <v-snackbar v-model="snackbar.show" top :timeout="snackbar.timeout" :color="snackbar.color">
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import transferenceManagebar from "../../components/admin/transferenceManagebar.vue";
import * as XLSX from "xlsx";

export default {
  components: { transferenceManagebar },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      bulkConfirming: false,
      position: "ผู้อำนวยการวิทยาลัย",
      periods: {},
      suggestions: [],
      unmatched: [],
      declined: [],
      selectedSuggestions: [],
      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },
      suggestionHeaders: [
        { text: "ผู้ขอย้าย", align: "left", value: "applicant_name" },
        { text: "สังกัดปัจจุบัน", align: "left", value: "college_name_now" },
        { text: "ปลายทางที่เสนอ", align: "left", value: "destination_college_name" },
        { text: "ตำแหน่งว่าง (jor18)", align: "center", value: "destination_capacity", sortable: false },
        { text: "คะแนนรวม", align: "center", value: "composite_score" },
        { text: "รายละเอียดคะแนน", align: "left", value: "breakdown", sortable: false },
        { text: "ยืนยันรายการนี้", align: "center", value: "confirm_action", sortable: false }
      ],
      declinedHeaders: [
        { text: "ผู้ขอย้าย", align: "left", value: "applicant_name" },
        { text: "ปลายทางที่เต็ม", align: "left", value: "destination_college_name" },
        { text: "ตำแหน่งว่างทั้งหมด (jor18)", align: "center", value: "destination_capacity" },
        { text: "คะแนนรวม", align: "center", value: "composite_score" }
      ],
      unmatchedHeaders: [
        { text: "ผู้ขอย้าย", align: "left", value: "applicant_name" },
        { text: "สังกัดปัจจุบัน", align: "left", value: "college_name_now" }
      ]
    };
  },

  async mounted() {
    await this.periodQuery();
  },

  methods: {
    async periodQuery() {
      let result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_type: "manage",
        periord_admin: "check"
      });
      this.periods = result_period.data;
    },

    async runMatchEngine() {
      this.loading = true;
      this.selectedSuggestions = [];
      try {
        const result = await this.$http.post("transference_manage_match_engine.php", {
          ApiKey: this.ApiKey,
          manage_time_s: this.periods.period_times,
          manage_year_s: this.periods.period_year,
          position_name: this.position
        });

        if (!result.data.status) {
          this.snackbar = { show: true, color: "error", icon: "mdi-alert-circle", text: result.data.message || "เกิดข้อผิดพลาด" };
          return;
        }

        this.suggestions = result.data.suggestions.map(s => ({ ...s, chosen_tfl: s.manage_location_id_tfl, confirming: false }));
        this.unmatched = result.data.unmatched;
        this.declined = result.data.declined;

        this.snackbar = {
          show: true,
          color: "success",
          icon: "mdi-check-circle",
          text: `ประมวลผลเสร็จสิ้น พบ ${this.suggestions.length} คู่ที่เสนอจับคู่ได้`
        };
      } finally {
        this.loading = false;
      }
    },

    /** เปลี่ยนปลายทางที่แอดมินเลือกเอง (จำกัดเฉพาะตัวเลือกที่ผู้ขอย้ายคนนั้นยื่นไว้และผ่าน gate) */
    onOverrideDestination(item) {
      const chosen = item.alternative_choices.find(c => c.manage_location_id_tfl === item.chosen_tfl);
      if (chosen) {
        item.manage_location_id_tfl = chosen.manage_location_id_tfl;
        item.destination_college_code = chosen.destination_college_code;
        item.destination_college_name = chosen.destination_college_name;
      }
    },

    exportToExcel() {
      const data = this.suggestions.map(item => ({
        ผู้ขอย้าย: item.applicant_name,
        สังกัดปัจจุบัน: item.college_name_now,
        ปลายทางที่เสนอ: item.destination_college_name,
        "ตำแหน่งว่าง (jor18)": `${item.destination_used}/${item.destination_capacity}`,
        คะแนนรวม: item.composite_score,
        คะแนนลำดับ: item.breakdown.pref_score,
        คะแนนผู้บังคับบัญชา: item.breakdown.no_score ? "ไม่มีคะแนน" : item.breakdown.sup_score,
        คะแนนอายุงาน: item.breakdown.sen_score
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Auto_Match");
      XLSX.writeFile(wb, `ผลเสนอจับคู่ย้ายอัตโนมัติ_${this.periods.period_times}_${this.periods.period_year}.xlsx`);
    },

    async confirmSelected() {
      this.bulkConfirming = true;
      try {
        for (const item of this.selectedSuggestions) {
          await this.confirmSuggestion(item);
        }
      } finally {
        this.bulkConfirming = false;
      }
    },

    /** ยืนยันการจับคู่ 1 รายการ: หาเลขที่ตำแหน่งว่างจริงที่ปลายทาง แล้วเรียก write-chain เดียวกับหน้ารายละเอียดผู้ยื่นย้าย */
    async confirmSuggestion(item) {
      item.confirming = true;
      try {
        const applicant = await this.$http.post("transference_manage.php", {
          ApiKey: this.ApiKey,
          manage_id_ref: item.manage_id_ref
        });
        const applicantData = applicant.data;

        const manPowerResult = await this.$http.post("man_power.php", {
          ApiKey: this.ApiKey,
          college_code: item.destination_college_code
        });
        const vacantPositions = (manPowerResult.data || []).filter(
          p => !p.status_booking
        );

        if (!vacantPositions.length) {
          this.snackbar = {
            show: true,
            color: "warning",
            icon: "mdi-alert",
            text: `ไม่พบเลขที่ตำแหน่งว่างจริงที่ ${item.destination_college_name} กรุณาไปมอบหมายด้วยมือที่หน้ารายละเอียดผู้ยื่นย้ายแทน`
          };
          return;
        }

        const chosenPosition = vacantPositions[0];

        const addreturn_man_power = {
          ApiKey: this.ApiKey,
          college_code: applicantData.college_code,
          id_position: applicantData.id_position,
          position: applicantData.position_name,
          case_vacancy: "ย้ายรอบ-" + applicantData.time_ss + "/" + applicantData.year_ss
        };
        const result_man_return = await this.$http.post("man_power.insert.php", addreturn_man_power);
        if (result_man_return.data.status != true) {
          this.snackbar = { show: true, color: "error", icon: "mdi-alert-circle", text: "บันทึกตำแหน่งเดิมคืนไม่สำเร็จ" };
          return;
        }

        await this.$http.post("man_power.update_process.php", {
          ApiKey: this.ApiKey,
          id_position: chosenPosition.id_position,
          status_booking: applicantData.id_card
        });

        const result = await this.$http.post("conditons_transfer_success.insert.php", {
          ApiKey: this.ApiKey,
          ctsid_ref: applicantData.manage_id_ref,
          ctstime_s: applicantData.time_ss,
          ctsyear_s: applicantData.year_ss,
          ctsid_postion_old: applicantData.id_position,
          ctscollege_code_old: applicantData.college_code,
          ctscollege_code: item.destination_college_code,
          ctsid_card: applicantData.id_card,
          ctsid_position: chosenPosition.id_position,
          ctsname_position: applicantData.position_name,
          ctsstatus_select: "demand"
        });

        if (result.data.status == true) {
          let userSession = JSON.parse(localStorage.getItem("user")) || {};
          await this.$http.post("data_syslog.insert.php", {
            ApiKey: this.ApiKey,
            user_account: userSession.user_name,
            event_log: "autoMatchConfirm",
            page_log: "transference_manage_auto_match",
            table_log: "conditons_transfer_success",
            detail_log: JSON.stringify({ manage_id_ref: item.manage_id_ref, score: item.composite_score, breakdown: item.breakdown }),
            date_times: this.date_today_log
          });

          this.suggestions = this.suggestions.filter(s => s !== item);
          this.selectedSuggestions = this.selectedSuggestions.filter(s => s !== item);
          this.snackbar = { show: true, color: "success", icon: "mdi-check-circle", text: `ยืนยันการย้ายของ ${item.applicant_name} เรียบร้อย` };
        } else {
          this.snackbar = { show: true, color: "error", icon: "mdi-alert-circle", text: "บันทึกผลการจับคู่ไม่สำเร็จ" };
        }
      } finally {
        item.confirming = false;
      }
    }
  },

  computed: {
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return dd + "/" + mm + "/" + yyyy + "/" + time;
    }
  }
};
</script>
